import { useNavigate } from 'react-router-dom';

const Logo = ({ className = 'hidden' }) => {
  const navigate = useNavigate();

  return (
    <div
      className="flex cursor-pointer items-center gap-2"
      onClick={() => navigate('/')}
      aria-label="Ir al inicio"
    >
      <img
        src={`${process.env.PUBLIC_URL}/Capacut.webp`}
        alt="logo de capacut3d"
        className="w-10 h-10 object-contain text-primary"
      />
      <span className={`${className} text-2xl font-bold`}>Capacut3d</span>
    </div>
  );
};

export default Logo;
